// extracted by mini-css-extract-plugin
export default {"box":"thanks_box__R9DSl","innerBox":"thanks_innerBox__3OkxR","thanksWrapper":"thanks_thanksWrapper__snQ2q"};